import { SearchTable } from '@aibees/elephant/types';
import { SearchDataNotFoundItems } from './types';

export const getConfig = (
  isLookalike: boolean
): Record<SearchTable, SearchDataNotFoundItems> => {
  return {
    [SearchTable.Company]: {
      title: isLookalike
        ? 'No Similar Companies Found!'
        : 'No Matching Result Found!',
      description: isLookalike
        ? 'The selected company has a lack of data. Please adjust your filters or select another company.'
        : 'We couldn’t find any companies matching your search. Please try another or clear your last filter.',
      src: isLookalike
        ? '/assets/icons/fingerprint.svg'
        : '/assets/icons/business.svg',
      buttonText: 'Go Back',
    },

    /*[SearchTable.Semantic]: {
      title: isLookalike
        ? 'No Similar Companies Found!'
        : 'No Matching Result Found!',
      description: isLookalike
        ? 'The selected company has a lack of data. Please adjust your filters or select another company.'
        : 'We couldn’t find any companies matching your search. Please try another or clear your last filter.',
      src: isLookalike
        ? '/assets/icons/fingerprint.svg'
        : '/assets/icons/business.svg',
      buttonText: 'Go Back',
    },*/

    [SearchTable.People]: {
      title: isLookalike
        ? 'No Similar People Found!'
        : 'No Matching Result Found!',
      description: isLookalike
        ? 'The selected people has a lack of data. Please adjust your filters or select another company.'
        : 'We couldn’t find any people matching your search. Please try another or clear your last filter.',
      src: isLookalike
        ? '/assets/icons/fingerprint.svg'
        : '/assets/icons/person.svg',
      buttonText: 'Go Back',
    },

    [SearchTable.Employees]: {
      title: isLookalike
        ? 'No Similar People Found!'
        : 'No Matching Result Found!',
      description: isLookalike
        ? 'The selected people has a lack of data. Please adjust your filters or select another company.'
        : 'We couldn’t find any people matching your search. Please try another or clear your last filter.',
      src: isLookalike
        ? '/assets/icons/fingerprint.svg'
        : '/assets/icons/person.svg',
      buttonText: 'Go Back',
    },

    [SearchTable.BuyingTeam]: {},
  };
};
